import { api } from '@services';

import { IUser } from '@models/User.model';

interface IPatchUser {
  id: string;
  blocked?: boolean;
  email?: string;
  name?: string;
  picture?: string;
  username?: string;
  role?: string;
  file?: File;
}

const patchUsers = async ({
  id,
  blocked,
  email,
  name,
  picture,
  username,
  role,
  file,
}: IPatchUser): Promise<IUser> => {
  const formData = new FormData();

  if (blocked) formData.append('blocked', blocked ? 'true' : 'false');
  if (email) formData.append('email', email);
  if (name) formData.append('name', name);
  if (picture) formData.append('picture', picture);
  if (username) formData.append('username', username);
  if (role) formData.append('role', role);
  if (file) formData.append('pictureFile', file);

  const { data: user } = await api.patch<IUser>(`/users/${id}/edit`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return user;
};

export { patchUsers };
